<template>
  <v-container
    fluid
    grid-list-md
  >
    <claims-filters @filter="apply" />
    <claim-submissions-table :filter="claimsFilter" />
    <claim-history-table :filter="historyFilter"/>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ClaimHistoryTable from "@/components/iSeriesClaims/ClaimHistoryTable.vue";
import ClaimSubmissionsTable from "@/components/iSeriesClaims/ClaimSubmissionsTable.vue";
import ClaimsFilters from "@/components/iSeriesClaims/ClaimsFilters.vue";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  components: {
    ErrorHandler,
    ClaimHistoryTable,
    ClaimSubmissionsTable,
    ClaimsFilters
  },
  data() {
    return {
      error: null,
      claimsFilter: null,
      historyFilter: null
    };
  },
  computed: {
    ...mapGetters("common", { settings: "settings" }),
    ...mapGetters("common", ["language"]),
  },
  methods: {
    ...mapActions("plansMembers", ["getCoverageByDate", "getPlan"]),
    ...mapActions("data", ["fetchFile"]),
    async downloadPdf(item) {
      const trans = item.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      );
      if (trans.length > 0) {
        try {
          const response = await this.fetchFile({
            url: trans[0].PhysicalFile.Path,
            filename: trans[0].DisplayName,
          });
          this.downloadBlob(new Blob([response.data]), this.file.PDFName);
        } catch (e) {
          console.log(e);
          this.e = e;
        }
      } else {
        this.error = {
          customMessage: this.$t("global.translation_not_found"),
        };
      }
    },
    downloadBlob(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      link.setAttribute("id", "link1"); //or any other extension
      document.body.appendChild(link);
      link.click();
      var element = document.getElementById("link1");
      element.parentNode.removeChild(element);
    },
    apply(filterQueries) {
      console.log(filterQueries);
      this.claimsFilter = filterQueries.claimsQuery;
      this.historyFilter = filterQueries.historyQuery;
    }
  },
};
</script>
